import { Component, OnDestroy, OnInit } from '@angular/core';
import { PopupNavigationItem } from '../../../../shared/components/popup-view/popup-navigation/popup-navigation.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Zone } from 'src/app/interfaces/zone';
import { PerspectiveMenuService } from '../../../../shared/modules/perspective-menu/perspective-menu.service';

@Component({
  selector: 'app-zone-popup-details',
  templateUrl: './zone-popup-details.component.html',
  styleUrls: ['./zone-popup-details.component.scss']
})
export class ZonePopupDetailsComponent implements OnInit, OnDestroy {
  public navItems: PopupNavigationItem[] = [
    {label: 'DETAILS', route: './', exact: true},
    {label: 'RULES', route: 'rules'},
  ];
  public zone$: Observable<Zone> = this.route.data
    .pipe(
      map(({zone}: { zone: Zone }) => zone)
    );

  constructor(private route: ActivatedRoute,
              private perspectiveMenu: PerspectiveMenuService) {
  }

  ngOnInit(): void {
    this.perspectiveMenu.popupSizeType = 'large';
  }

  ngOnDestroy(): void {
    this.perspectiveMenu.popupSizeType = 'normal';
  }

}
